import { useGenerateBreadcrumbList } from '@/hooks/useGenerateBreadcrumbList';
import type { SocketIOServerType } from '@/services/socket-io-api/socketIOApi';
import { ModelType } from '@tarslib/types/lib/common';
import React from 'react';
import { ApiCustomFieldList } from '../api-custom-field-list/ApiCustomFieldList';
import { BottomBanner } from '../bottom-banner/BottomBanner';
import { DocsBreadcrumb } from '../docs-breadcrumb/DocsBreadcrumb';
import { EnvironmentUrl } from '../environment-url/EnvironmentUrl';
import { Footer } from '../footer/Footer';
import { LastModifiedAt } from '../last-modified-at/LastModifiedAt';
import { MarkdownViewer } from '../markdown-viewer/MarkdownViewer';
import { Paginator } from '../paginator/Paginator';
import { RequestParameter } from '../request-parameter/RequestParameter';
import { ResourceHeader } from '../resource-header/ResourceHeader';
import { SpecialFileMenu } from '../special-file-menu/SpecialFileMenu';
import { TagList } from '../tag-list/TagList';
export type SocketIOApiContentProps = {
  value: SocketIOServerType;
};

export function SocketIOApiContent(props: SocketIOApiContentProps) {
  const { value } = props;

  const breadcrumbList = useGenerateBreadcrumbList();
  const requestParameterValue = React.useMemo(() => {
    return {
      type: ModelType.SOCKET_IO_API as const,
      parameters: value.parameters,
    };
  }, [value.parameters]);

  const tagsValue = React.useMemo(() => {
    return value.tags ?? [];
  }, [value.tags]);

  const environmentUrlValue = React.useMemo(() => {
    return {
      type: ModelType.SOCKET_IO_API as const,
      path: value.path,
    };
  }, [value]);

  return (
    <div className="os:pt-5">
      <DocsBreadcrumb
        className="mb-2 hidden os:flex"
        value={breadcrumbList}
        rightNode={!!breadcrumbList.length && <SpecialFileMenu />}
      />

      <ResourceHeader
        name={value.name}
        className="mb-4"
        status={value.status}
        suffix={!breadcrumbList.length && <SpecialFileMenu className="max-os:hidden" />}
      />

      <EnvironmentUrl value={environmentUrlValue} className="mb-6" />

      <TagList className="mb-2" tags={tagsValue} />

      <ApiCustomFieldList className="mb-6" />

      <MarkdownViewer value={value.description} inDocView enableHeaderPlugin className="mb-6" />

      <RequestParameter className="mb-8" value={requestParameterValue} />

      <BottomBanner className="mb-8" />

      <LastModifiedAt className="mb-14 mt-8" />

      <Paginator className="mb-10" />

      <Footer />
    </div>
  );
}
